import * as Yup from 'yup'

const schema = Yup.object().shape({
	username: Yup.string().required('Username dan Kata Sandi Tidak Boleh Kosong'),
	password: Yup.string().required('Username dan Kata Sandi Tidak Boleh Kosong'),
})

export default schema
